export enum UpdatePasswordStatus {
  IDLE = 'idle',
  INVALID_PASSWORD = 'invalidPassword',
  SUCCESS = 'success',
}

export default null;
